import React, { useEffect } from 'react';
import { Section } from './styles';
import { List, Button, Input, Comment, Form, message } from 'antd';
import { withTranslation } from 'react-i18next';
import { UNIQUE_TICKET_MODAL as trans } from './TranslationValues';
import { useState } from 'react';
import { addComment } from '../../utils/services/supportAPI';
import moment from "moment";
import { Modal, Upload, Divider } from 'antd';
import ShowMoreContent from './ShowMoreContent';
import { attachImage } from '../../utils/services/supportAPI';
import { stripHTML } from './Tool';

const NAMESPACE = ['UNIQUE_TICKET_MODAL']
const TicketContentModal = props => {
  const { selectedItem, t } = props;
  const { TextArea } = Input;

  const [comment, setComment] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [value, setValue] = useState('');
  const [totalComment, setTotalComment] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState([]);

  function getLastAfterDot(inputString) {
    const parts = inputString.split('.');
    if (parts.length > 1) {
      return parts.pop(); // Get the last part after the last dot
    }
    // Handle the case when there is no dot in the string.
    return null; // or any other suitable value
  }

  const refactorAttachment = (arrayList,type) => {
    console.log()
    const arrayValue = arrayList;
    const imageAcceptFormat = ['png', "jpg", "jpeg"];
    const showImageFormat = ['png', "jpg", "jpeg", "gif", "bmp", "svg", "webp"];
    const imageFormat = type === 'show' ? showImageFormat : imageAcceptFormat
    const specificValues = arrayValue.reduce((result, obj, index) => {
      console.log('index', index)
      if (imageFormat.includes(getLastAfterDot(obj.name.toLowerCase()))) {
        obj.uid = Math.random();
        obj.url = obj.link;
        obj.status = 'done';
        result.push(obj);
      }
      return result;
    }, []);

    return specificValues;
  }

  const CommentList = ({ comments }) => (
    <>
      {comments.map((list) => {
        return (
          <>
            <List
              dataSource={[list]}
              itemLayout="horizontal"
              renderItem={props => <Comment {...props} />}
            />
            {list.attachments &&
              <Upload
                listType="picture-card"
                fileList={refactorAttachment(list.attachments,"upload")}
                onPreview={(file) => handlePreview(file)}
                onChange={uploadImage}
                customRequest={customRequest}
                autoUpload={false}
              />}
          </>
        )
      })}
    </>
  );

  const uploadButton = (
    <div>
      <div style={{ marginTop: 8 }}>{t(trans.UPLOAD_LABEL.key, trans.UPLOAD_LABEL.value)}</div>
    </div>
  );

  const handleChange = e => {
    setValue(stripHTML(e.target.value));

  };

  const handleSubmit = async () => {
    setSubmitting(true);
    const data = {
      "ticketId": selectedItem?.ticketId,
      "attachmentIds": [selectedItem?.ticketId],
      "content": value
    }
    const result = await addComment(data);
    setValue('');
    setComment([{
      author: selectedItem?.createdBy,
      content: <div>{value}</div>,
      datetime: moment().fromNow(),
    }, ...comment]);

    setSubmitting(false);
  };


  const handleCancel = () => { setPreviewOpen(false) }

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || (file.preview));
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };


  const uploadImage = async (file) => {
    const fileArray = file.fileList;

    if (fileArray.length > 5) {
      message.error(t(trans.UPLOAD_LIMIT_ERROR.key, trans.UPLOAD_LIMIT_ERROR.value));
      return false; // Prevent adding more files once the limit is reached
    }

    if (fileList > 5) {
      message.error(t(trans.UPLOAD_LIMIT_ERROR2.key, trans.UPLOAD_LIMIT_ERROR2.value));
      return;
    }

    const fileExtension = file.file.name.split('.').pop().toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png'];
    if (!imageExtensions.includes(fileExtension)) {
      message.error(
        t(trans.UPLOAD_FILE_TYPE_ERROR.key, trans.UPLOAD_FILE_TYPE_ERROR.value, {
          value: imageExtensions.join(', '),
        }),
      );
      return;
    }

    let form = new FormData();
    form.append('ticketId', selectedItem.ticketId);
    form.append('file', file.file.originFileObj);

    const result = await attachImage(form);
    if (!result.statusCode === 2111) {
      message.error(trans.SOMETHING_WRONG_ERROR_MESSAGE)
    }

    setTimeout(() => {
      const result = fileArray.map((list, index) => {
        list.status = 'done';
        return list;
      })
      setFileList(result);
    }, 1000);
  };

  const viewfile = () => {
    const image = new Image();
    image.src = previewImage;
    const imgWindow = window.open(previewImage);
    imgWindow.document.write(image.outerHTML);
  }


  const customRequest = (options) => { };

  function containsDivElement(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const divElement = doc.querySelector('div');
    return divElement !== null;
  }

  useEffect(() => {
    if (selectedItem.comments.length !== 0) {
      const response = selectedItem.comments.map((list) => {
        list.author = list.commenterName;
        list.datetime = moment(list.commentedTime, "YYYYMMDD").fromNow();
        if (containsDivElement(list.content)) {
          const item = list.content.replace(/<[^>]*>/g, '');
          list.content = <p>{item}</p>
          return list;
        }
        return list;
      })
      setComment(response)
    }
  }, [selectedItem])


  useEffect(() => {
    selectedItem?.attachments && setFileList(refactorAttachment(selectedItem?.attachments,"show"));
  }, [])

  return (
    <Section className="ticketModalSection">
      <div className="ticketModal">
        <div className="ticketCard card-details">
          <div className="infoCard id">
            <strong className="key">{t(trans.TICKET_ID_LABEL.key, trans.TICKET_ID_LABEL.value)}</strong>
            <div className="value">{selectedItem?.ticketId}</div>
          </div>
          <div className="infoCard">
            <strong className="key">{t(trans.SUBJECT_LABEL.key, trans.SUBJECT_LABEL.value)}</strong>
            <div className="value">{selectedItem?.subject}</div>
          </div>
          <div className="infoCard">
            <strong className="key">{t(trans.RAISED_ON_LABEL.key, trans.RAISED_ON_LABEL.value)}</strong>
            <div className="value">{moment(selectedItem?.createdOn).format('ll')}</div>
          </div>
          {/* <div className="infoCard">
            <strong className="key">{t(trans.CLASSIFICATION_LABEL.key, trans.CLASSIFICATION_LABEL.value)}</strong>
            <div className="value">{selectedItem?.classification}</div>
          </div> */}
          <div className="infoCard">
            <strong className="key">{t(trans.PRIORITY_LABEL.key, trans.PRIORITY_LABEL.value)}</strong>
            <div className="value">{selectedItem?.priority}</div>
          </div>

          <div className="infoCard">
            <strong className="key">{t(trans.PRODUCTNAME_LABEL.key, trans.PRODUCTNAME_LABEL.value)}</strong>
            <div className="value">{selectedItem?.productName}</div>
          </div>
          <div className="infoCard">
            <strong className="key">{t(trans.STATUS_LABEL.key, trans.STATUS_LABEL.value)}</strong>
            <div className="value">{selectedItem?.status}</div>
          </div>
          <div className="infoCard">
            <strong className="key">{t(trans.ASSIGNEE_LABEL.key, trans.ASSIGNEE_LABEL.value)}</strong>
            <div className="value">{selectedItem?.assignedToName}</div>
          </div>
          {selectedItem?.resolutionDate &&
            <div className="infoCard">
              <strong className="key">{t(trans.RESOLUTION_DATE_LABEL.key, trans.RESOLUTION_DATE_LABEL.value)}</strong>
              <div className="value">{moment(selectedItem?.resolutionDate).format('ll')}</div>
            </div>
          }
          {selectedItem?.closedTime &&
            <div className="infoCard">
              <strong className="key">{t(trans.CLOSED_DATE_LABEL.key, trans.CLOSED_DATE_LABEL.value)}</strong>
              <div className="value">{moment(selectedItem?.closedTime).format('ll')}</div>
            </div>
          }

        </div>
        <div className="ticketCard">
          <div className="infoCard single description">
            <strong className="key">{t(trans.TICKET_DESCRIPTION_LABEL.key, trans.TICKET_DESCRIPTION_LABEL.value)}</strong>
            <div className="value"> {selectedItem.description && <ShowMoreContent text={selectedItem?.description} characterLimit={500} />}</div>
          </div>
        </div>
        {selectedItem.resolution &&
          <div className="ticketCard">
            <div className="infoCard single description">
              <strong className="key">{t(trans.TICKET_RESOLUTION_LABEL.key, trans.TICKET_RESOLUTION_LABEL.value)}</strong>
              <div className="value"> {selectedItem.resolution && <ShowMoreContent text={selectedItem?.resolution} characterLimit={500} />}</div>
            </div>
          </div>}
        <div className="ticketCard comments">
          <div className="infoCard  description">
            <strong className="key">{t(trans.TICKET_COMMENTS_LABEL.key, trans.TICKET_COMMENTS_LABEL.value)}</strong>
          </div>
          <div>
            <Comment
              content={
                <div>
                  <TextArea rows={4} onChange={(e) => handleChange(e)} value={value} maxLength={5000} />
                  <Form.Item>
                    <Button disabled={!value} htmlType="submit" loading={submitting} onClick={() => handleSubmit()} type="primary" className={value ? 'add-comment' : ""}>
                      {t(trans.ADD_COMMENT_LABEL.key, trans.ADD_COMMENT_LABEL.value)} 
                    </Button>
                  </Form.Item>
                </div>
              }
            />
            {comment.length > 0 && <CommentList comments={totalComment ? comment : comment.slice(0, 10)} />}
          </div>
          {comment.length > 10 &&
            <>
              <Divider />
              <a className='showmore-text' onClick={() => setTotalComment(!totalComment)}> {totalComment ? t(trans.SHOW_LESS_LABEL.key, trans.SHOW_LESS_LABEL.value) : t(trans.SHOW_MORE_LABEL.key, trans.SHOW_MORE_LABEL.value)}</a>
            </>
          }
        </div>

        <div className='ticketCard'>
          <div className="infoCard  description">
            <strong className="key">{t(trans.TICKET_ATTACHMENT_LABEL.key, trans.TICKET_ATTACHMENT_LABEL.value)}</strong>
          </div>
          <Upload
            accept='.jpg,.png,.jpeg'
            listType="picture-card"
            fileList={fileList}
            onPreview={(file) => handlePreview(file)}
            onChange={uploadImage}
            customRequest={customRequest}
            autoUpload={false}
          >
            {fileList.length >= 5 ? null : uploadButton}
          </Upload>

          <Modal visible={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel} className='image-modal'>
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
            <a onClick={() => viewfile()} className='view-file'>{t(trans.VIEW_FILE_LABEL.key, trans.VIEW_FILE_LABEL.value)}</a>
          </Modal>
        </div>
      </div>
    </Section>
  );
};

export default withTranslation(NAMESPACE)(TicketContentModal);
